<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
import sma from "@/utils/sma";

export default {
  async created() {
    if (this.$store.state.user.user) {
      return;
    }
    try {
      const res = await this.$axios.post(`/User/getUserInfo`);
      this.$store.commit("user/SET_USER", res.data);
    } catch (error) {
      this.$notify({
        type: "danger",
        message: error.errorMsg || "获取用户信息失败",
        duration: 2000,
      });
    }

    // iOS 禁止侧滑返回
    sma.sliderClose(1);
    // iOS 禁用下拉刷新
    sma.needFreshAction(1);
  },
};
</script>
<style lang="scss">
body {
  font-family: "PingFang SC", system-ui, -apple-system, BlinkMacSystemFont,
    segoe ui, Roboto, Helvetica, Arial, "Microsoft Yahei", sans-serif,
    apple color emoji, segoe ui emoji, segoe ui symbol;

  /* IOS禁止微信调整字体大小 */
  -webkit-text-size-adjust: 100% !important;
  -moz-text-size-adjust: 100% !important;
  text-size-adjust: 100% !important;

  /* 禁止选中文字 */
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}

#app {
  height: 100vh;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  background: #fff;
}

.van-image {
  vertical-align: middle;
}

// 自定义弹窗
.custom-dialog {
  width: 318px;
  overflow: visible;
  border-radius: 14px;

  .van-dialog__header {
    @include title;
  }

  .custom-dialog_content {
    padding: 20px;
    font-size: 15px;
    line-height: 25px;
    color: #333;
    text-align: center;
  }

  .van-dialog__footer {
    $border-color: #3683f9;

    justify-content: space-between;
    padding: 0 30px 31px;

    &.van-hairline--top::after {
      border-color: #fff;
    }

    .van-button {
      height: 45px;
      font-size: 15px;
      color: #fff;
      background: linear-gradient(to right, #43a3f5, #3a5bfc);
      border-radius: 64px;
    }
    .van-dialog__cancel {
      margin-right: 18px;
    }
  }
}
.tab-card {
  height: calc(100vh - 66px);
  overflow: hidden;
  background: #fff;
  border-radius: 30px 30px 0 0;
}
.tab-card-liner {
  height: calc(100vh - 66px);
  overflow: hidden;
  background: #fff;
  border-radius: 30px 30px 0 0;
}
.tab-card-short {
  height: calc(100vh - 66px);
  overflow: hidden;
  background: #fff;
  border-radius: 30px 30px 0 0;
}

// 自定义tab
.custom-tabs {
  .van-tabs__wrap {
    height: 31px;
    padding: 10px 0;
    .van-tabs__nav {
      align-items: flex-start;
      .custom-tab {
        font-size: 16px;
        &.van-tab--active {
          font-size: 16px;
          font-weight: 500;
          color: #ffd36e;
        }
      }
    }
  }
  .tab-card {
    height: calc(100vh - 51px);
    overflow: hidden;
    background: #fff;
    border-radius: 20px 20px 0 0;
  }
}

.tab-labels {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  .tab-label {
    padding: 15px 50px;
    font-size: 16px;
    line-height: 16px;
    color: #fff;
    cursor: pointer;
    background: linear-gradient(to right, #bfbfbf, #bfbfbf);
    box-shadow: 0 0 3px #fff inset;
    &-active {
      background: linear-gradient(to bottom, #305ddf, #305ddf);
      box-shadow: 0 0 3px #fff inset;
    }
  }
  :first-child {
    border-radius: 20px 0 0 0;
  }
  :last-child {
    border-radius: 0 20px 0 0;
  }
}
// 自定义列表
.custom-table {
  margin-top: 10px;

  .custom-thead {
    height: 15px;
    padding: 10px 0;
    font-size: 14px;
    line-height: 14px;
    color: #333;
    .van-col.left {
      text-align: left;
    }
    .van-col.center {
      text-align: center;
    }
    .van-col.right {
      text-align: right;
    }
  }

  .custom-tbody {
    box-sizing: border-box;
    @include safe-area-bottom;

    .van-row {
      display: flex;
      align-items: center;
      height: 50px;
      font-size: 16px;
      line-height: 20px;
      color: $black;
      > .van-col.left {
        text-align: left;
      }
      > .van-col.center {
        text-align: center;
      }
      > .van-col.right {
        text-align: right;
      }
    }

    &.stripe {
      .van-row:nth-child(odd) {
        background-color: rgba($color: $blue, $alpha: 0.05);
      }
    }

    .custom-status {
      padding: 20px;
      font-size: 14px;
      line-height: 20px;
      text-align: center;
      .custom-status__loading {
        color: $gray-color;
      }
      .custom-status__finished {
        color: $black;
      }
      .custom-status__more {
        color: $blue;
      }
    }
  }
}
.btn-outer {
  height: 34px;
  background: #eb860c;
  border: 1px solid #333;
  border-radius: 10px;
  .btn-inner {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 30px;
    font-size: 17px;
    font-weight: 600;
    color: #0a2abd;
    background: #fcc416;
    border-bottom: 1px solid #333;
    border-radius: 10px;
  }
}
</style>
